import { IMetaData, IMetaUrl } from 'interfaces/pages';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useQueryParameters } from 'hooks/useQueryString';
import { useParams } from 'react-router-dom';
import { BuildAndPriceParms } from 'interfaces/buildAndPrice';

export interface IMetadataProps {
  metadata: IMetaData[];
  canonicalUrls: IMetaUrl[];
}

const Metadata = (props: IMetadataProps): JSX.Element => {
  const queryParameters = useQueryParameters();
  const modelYearQS = queryParameters.get('modelyear');
  const modelSeriesQS = (
    queryParameters.get('vehiclemodelseries') ||
    queryParameters.get('modelseries')
  )?.toLocaleLowerCase();
  const { vehicleModelSeries } = useParams<BuildAndPriceParms>();
  const fullPath = window.location.pathname + window.location.search;

  const modelName =
    modelSeriesQS?.toLocaleLowerCase() ||
    vehicleModelSeries?.toLocaleLowerCase();

  const { metadata, canonicalUrls } = props;

  const foundMetadata: IMetaData | undefined =
    modelYearQS && modelName
      ? metadata.find(
          (meta) =>
            meta.modelName?.toLocaleLowerCase() === modelName &&
            meta.modelYear?.toString() === modelYearQS
        )
      : metadata.length > 0
      ? metadata[0]
      : undefined;

  if (foundMetadata) {
    return (
      <Helmet>
        {foundMetadata.title && <title>{foundMetadata.title}</title>}
        {foundMetadata.description && (
          <meta name="description" content={foundMetadata.description} />
        )}
        {foundMetadata.keywords && (
          <meta name="keywords" content={foundMetadata.keywords} />
        )}
        {canonicalUrls.length &&
          canonicalUrls.map((url: IMetaUrl) => (
            <link
              key={`canonUrl${url.url}`}
              rel={url.type}
              href={`${url.url}${fullPath}`}
              hrefLang={url.language}
            />
          ))}
      </Helmet>
    );
  }
  return <> </>;
};

export default Metadata;
